import { HStack, P, VStack, legacyTextStyles } from '@eluve/components';

// Types

export type StartingChatMessage = {
  id: string;
  title: string;
  description?: string;
  content: string;
};

type StartingChatMessageCardProps = {
  message: StartingChatMessage;
  onSelectMessage: (content: string) => void;
};

// Components

export const StartingChatMessageCard = ({
  message,
  onSelectMessage,
}: StartingChatMessageCardProps) => (
  <HStack
    className="cursor-pointer rounded-lg border border-border-primary bg-bg-primary p-4 hover:border-border-secondary hover:bg-bg-secondary"
    key={message.id}
    onClick={() => onSelectMessage(message.content)}
  >
    <VStack gap={1}>
      <P>{message.title}</P>
      <P
        className={legacyTextStyles.body({
          color: 'tertiary',
          size: 'm',
        })}
      >
        {message.description ?? message.content}
      </P>
    </VStack>
  </HStack>
);
